export default IconTemperaturePlus => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-temperature-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5" />
  <path d="M8 9l4 0" />
  <path d="M16 9l6 0" />
  <path d="M19 6l0 6" />
</svg>`;